import { useMutation } from 'react-query';
import axiosDefault from 'axios';

import API from '../constants/API';
import axios from '../constants/axios';
import { getBase64 } from '../store/common';
import { isDev, localServerURL, serverURL } from '../utils/utils';
import useSimpleLoading from './useSimpleLoading';

const useUploadImage = () => {
  const { onLoading, onLoadingEnd, onError } = useSimpleLoading();

  return useMutation(
    async ({ imageData, type, base64 }) => {
      const baseURL = base64 ? imageData : await getBase64(imageData);
      if (base64) {
        return axiosDefault.post(
          `${isDev ? localServerURL : serverURL}${API.uploadImage}`,
          { type, imageData: baseURL },
          {
            baseURL: isDev ? localServerURL : serverURL,
            withCredentials: true,
          },
        );
      }
      return axios.post(
        `${isDev ? localServerURL : serverURL}${API.uploadImage}`,
        { type, imageData: baseURL },
      );
    },
    {
      onMutate: onLoading,
      onSettled: onLoadingEnd,
      onError,
    },
  );
};

export default useUploadImage;
